import React from "react";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";
import icon1 from "@img/nilaiinti/icon1.png"
import icon2 from "@img/nilaiinti/icon2.png"
import icon3 from "@img/nilaiinti/icon3.png"
import icon4 from "@img/nilaiinti/icon4.png"
import icon5 from "@img/nilaiinti/icon5.png"

const NilaiInti = () => {
  const [coreValue, setCoreValue] = useState([]);

  useEffect(() => {
    fetchCoreValue();
  }, []);

  const fetchCoreValue = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/core-values"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data nilai inti");
      }
      const data = await response.json();
      setCoreValue(data.data[0] || []);
    } catch (error) {
      setCoreValue([]);
    }
  };

  const icons = [icon1, icon2, icon3, icon4, icon5];

  return (
    <>
      <div className="w-full mobile:mt-24 lg:mt-28">
        <div className="mx-auto w-full h-full">
          <img
            className="mobile:w-full mobile:h-full object-cover lg:mx-auto lg:w-[85%] lg:h-auto lg:rounded-xl"
            src={`${process.env.REACT_APP_API_URL}/${coreValue.image}`}
            alt="Header Nilai Inti"
          />
        </div>
      </div>
      <div className="mt-20 mb-32">
        <div className="container mx-auto px-4 py-8 mt-10">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 justify-items-center">
            {coreValue?.content?.map(
              ({ content_title, content_description, icon }, index) => (
                <div
                  className="rounded-es-3xl rounded-se-3xl bg-gradient-to-b from-[#1c75ac] to-[#e01f31] p-1 shadow-md"
                >
                <div
                  key={index}
                  className="bg-white rounded-es-3xl rounded-se-3xl p-6 h-full flex flex-col items-center text-center"
                >
                  <div className="bg-[#1c75ac] text-white rounded-full p-3 mb-4">
                    <img src={icons[index]} alt={`Icon ${index + 1}`} className="h-8 w-8" />
                  </div>
                  <h3 className="text-xl font-bold text-[#e01f31] mb-2">
                    {content_title}
                  </h3>
                  <div
                    className="text-gray-700 text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: content_description }}
                  />
                </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default NilaiInti;
